import axios from "axios";
import { getToken } from "./auth";

// export const baseURL = "https://magicgym-backend.siglonet.com";
// export const baseURL = "http://localhost:8000";
// export const baseURL = "https://manage-backend.magicgym.co.mz";
// export const baseURL = "https://test-backend.magicgym.co.mz";
// export const baseURL = "http://managegym-backend.siglonet.com";
// export const baseURL = "https://testgym-backend.siglonet.com";

export const baseURL = "https://backend.magicgym.tech";
const api = axios.create({
  baseURL: baseURL + "/api",
});

api.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
